import { createSelector } from "reselect";
import { AppState } from "../rootReducer";

const getTaskListPending = (state: AppState) => state.tasks.pending;
const getTaskList = (state: AppState) => state.tasks.tasks;
const getTaskListError = (state: AppState) => state.tasks.error;

export const getTaskListSelector = createSelector(getTaskList, (tasks) => tasks);
export const getTaskListPendingSelector = createSelector(getTaskListPending,(pending) => pending);
export const getTaskListErrorSelector = createSelector(getTaskListError, (error) => error);

const getLoaderListPending = (state: AppState) => state.getLoaders.pending;
const getLoaderList = (state: AppState) => state.getLoaders.getLoaders;
const getLoaderListError = (state: AppState) => state.getLoaders.error;

export const getLoaderListSelector = createSelector(getLoaderList, (getLoaders) => getLoaders);
export const getLoaderListPendingSelector = createSelector(getLoaderListPending,(pending) => pending);
export const getLoaderListErrorSelector = createSelector(getLoaderListError, (error) => error);

const getEventTaskListPending = (state: AppState) => state.eventTasks.pending;
const getEventTaskList = (state: AppState) => state.eventTasks.eventTasks;
const getEventTaskListError = (state: AppState) => state.eventTasks.error;

export const getEventTaskListSelector = createSelector(getEventTaskList, (eventTasks) => eventTasks);
export const getEventTaskListPendingSelector = createSelector(getEventTaskListPending,(pending) => pending);
export const getEventTaskListErrorSelector = createSelector(getEventTaskListError, (error) => error);


const getEventListPending = (state: AppState) => state.events.pending;
const getEventList = (state: AppState) => state.events.events;
const getEventListError = (state: AppState) => state.events.error;

export const getEventListSelector = createSelector(getEventList, (events) => events);
export const getEventListPendingSelector = createSelector(getEventListPending,(pending) => pending);
export const getEventListErrorSelector = createSelector(getEventListError, (error) => error);

const getInboundListPending = (state: AppState) => state.inboundEvents.pending;
const getInboundList = (state: AppState) => state.inboundEvents.inboundEvents;
const getInboundListError = (state: AppState) => state.inboundEvents.error;

export const getInboundListSelector = createSelector(getInboundList, (inboundEvents) => inboundEvents);
export const getInboundListPendingSelector = createSelector(getInboundListPending,(pending) => pending);
export const getInboundListErrorSelector = createSelector(getInboundListError, (error) => error);

const getOutboundListPending = (state: AppState) => state.outboundEvents.pending;
const getOutboundList = (state: AppState) => state.outboundEvents.outboundEvents;
const getOutboundListError = (state: AppState) => state.outboundEvents.error;

export const getOutboundListSelector = createSelector(getOutboundList, (outboundEvents) => outboundEvents);
export const getOutboundListPendingSelector = createSelector(getOutboundListPending,(pending) => pending);
export const getOutboundListErrorSelector = createSelector(getOutboundListError, (error) => error);

// Post Task
const postTaskPending = (state: AppState) => state.taskId.pending;
const postTask = (state: AppState) => state.taskId.taskId;
const postTaskError = (state: AppState) => state.taskId.error;

export const postTaskPendingSelector = createSelector(postTaskPending, (pending) => pending);
export const postTaskSelector = createSelector(postTask, (taskId) => taskId);
export const postTaskErrorSelector = createSelector(postTaskError, (error) => error);

const getTaskConnectionPending = (state: AppState) => state.taskConnection.pending;
const getTaskConnectionList = (state: AppState) => state.taskConnection.taskConnection;
const getTaskConnectionError = (state: AppState) => state.taskConnection.error;

export const getTaskConnectionSelector = createSelector(getTaskConnectionList, (taskConnection) => taskConnection);
export const getTaskConnectionPendingSelector = createSelector(getTaskConnectionPending,(pending) => pending);
export const getTaskConnectionErrorSelector = createSelector(getTaskConnectionError, (error) => error);

// Post Task Connection
const postTaskConnectionPending = (state: AppState) => state.postTaskConnection.pending;
const postTaskConnection = (state: AppState) => state.postTaskConnection.taskConnectionId;
const postTaskConnectionError = (state: AppState) => state.postTaskConnection.error;

export const postTaskConnectionPendingSelector = createSelector(postTaskConnectionPending, (pending) => pending);
export const postTaskConnectionSelector = createSelector(postTaskConnection, (taskId) => taskId);
export const postTaskConnectionErrorSelector = createSelector(postTaskConnectionError, (error) => error);

// PUT task

const putDataPending = (state: AppState) => state.putTask.pending;
const putTask = (state: AppState) => state.putTask.taskId;
const putDataError = (state: AppState) => state.putTask.error;

export const putTaskPendingSelector = createSelector(putDataPending, (pending) => pending);
export const putTaskSelector = createSelector(putTask, (task) => task);
export const putTaskErrorSelector = createSelector(putDataError, (error) => error);